import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoaderService } from './loader.service';
import { LoaderInterceptor } from './loader.interceptor';

@NgModule({ declarations: [], imports: [], providers: [LoaderService, LoaderInterceptor, provideHttpClient(withInterceptorsFromDi())] })
export class LoaderModule {}
